/**
 * @public `Small` is part of the public Spinner size API but not handled in the internal switch.
 */
export enum ButtonSpinnerSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export type ButtonSpinnerSizeType = keyof typeof ButtonSpinnerSize;

export interface ButtonSpinnerProps {
  size?: ButtonSpinnerSizeType;
  color?: 'Primary' | 'White' | 'Black';
}
